module.exports = __webpack_public_path__ + "2afeebb89fc6684e4e485144c8ca8317.png";